/**
 * This is the entry file for webpack/config/front.js
 */


// Nette forms
import netteForms from 'nette-forms';
window.Nette = netteForms;
netteForms.initOnLoad();


// Cookies
import '/node_modules/vanilla-cookieconsent/dist/cookieconsent.js';


// Application
import '/node_modules/owl.carousel/dist/owl.carousel.min.js';
import '/webpack/assets/js/netteFormsExtension.js';
import '/webpack/assets/js/front/general.js';
